import React from "react";
import { Headline, SectionContent, Text } from "../../../../components";
import { applyKey } from "../../../../utils";

const HeadlineSection = () => {
  return (
    <SectionContent>
      <Text textSize="lg" as="div">
        <p>teste1</p>
        <p>teste2</p>
        <p>teste3</p>
      </Text>
      {applyKey(["1", "2", "3", "4", "5", "6"], (nivel) => (
        <Headline nivel={nivel} text={`Titulo h${nivel} padrão`} />
      ))}
      <hr />

      {["1", "2", "3", "4", "5", "6", "7", "8"]
        .map((styleAs) =>
          applyKey(["1", "2", "3", "4", "5", "6"], (nivel) => (
            <Headline
              nivel={nivel}
              styleAs={styleAs}
              text={`Titulo h${nivel} estilizado como h${styleAs}`}
            />
          ))
        )
        .reduce((a, b) => a.concat(b), [])}
    </SectionContent>
  );
};

HeadlineSection.propTypes = {};

export default HeadlineSection;
